













import Vue from 'vue';

// components
import DesktopAppContainer from '@/container/common/DesktopAppContainer.vue';
import TaskpoolContainer from '@/container/taskpool/TaskpoolContainer.vue';
import TaskpoolChannelsContainer from '@/container/taskpool/TaskpoolChannelsContainer.vue';

export default Vue.extend({
  name: 'TaskpoolScene',

  components: {
    DesktopAppContainer,
    TaskpoolContainer,
    TaskpoolChannelsContainer,
  },

});
